export interface FinanceOverviewIncome {
    sales_income: number | string
    recharge_amount: number | string
    consume_amount: number | string
    online_sales_income?: number | string
    online_recharge_amount?: number | string
    online_consume_amount?: number | string
    balance_refund_amount?: number | string
}

export interface FinanceOverviewMetrics extends FinanceOverviewIncome {
    order_count: number
    refund_amount: number | string
    refund_order_count: number
    recharge_count: number
    online_order_count?: number
    online_refund_amount?: number | string
    online_refund_order_count?: number
    online_recharge_count?: number
}

export function getCombinedFinanceOverview<T extends FinanceOverviewMetrics>(row: T): T {
    const add = (offline: number | string, online?: number | string) => getSum(getAmount(offline), getAmount(online))

    return {
        ...row,
        sales_income: add(row.sales_income, row.online_sales_income),
        order_count: add(row.order_count, row.online_order_count),
        refund_amount: add(row.refund_amount, row.online_refund_amount),
        refund_order_count: add(row.refund_order_count, row.online_refund_order_count),
        recharge_amount: add(row.recharge_amount, row.online_recharge_amount),
        recharge_count: add(row.recharge_count, row.online_recharge_count),
        consume_amount: add(row.consume_amount, row.online_consume_amount),
        online_sales_income: 0,
        online_order_count: 0,
        online_refund_amount: 0,
        online_refund_order_count: 0,
        online_recharge_amount: 0,
        online_recharge_count: 0,
        online_consume_amount: 0,
    }
}

function getAmount(value?: number | string): number {
    return value == null || value === '' ? 0 : +value
}

function getSum(...args: number[]): number {
    return +args.reduce((sum, item) => sum + item, 0).toFixed(2)
}

/**
 * PC 数据概览与零售通保持同一总收款口径：
 * 线下总收款 + 线上总收款 - 会员余额退款。
 */
export function getFinanceOverviewTotalIncome(row: FinanceOverviewIncome): number {
    return getSum(
        getAmount(row.sales_income),
        getAmount(row.recharge_amount),
        -getAmount(row.consume_amount),
        getAmount(row.online_sales_income),
        getAmount(row.online_recharge_amount),
        -getAmount(row.online_consume_amount),
        -getAmount(row.balance_refund_amount),
    )
}
